import {
  HStack,
  Heading,
  Spacer,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Table,
  TableContainer,
  Tabs,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useToast,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { addDocumentFirebase, getCollectionFirebase, getSingleDocumentFirebase, updateDocumentFirebase } from '../../Api/firebaseApi';
import BackButtons from '../../Components/Buttons/BackButtons';
import { data } from '../../Components/Sidebar/DataMenu';
import useUserStore from '../../Hooks/Zustand/Store';
import { extractPaths } from '../../Utils/roleAccessUtils';
import AccessPathTabs from '../../Components/Access/AccessPathTabs';
import { useParams } from 'react-router-dom';
import AccessAddNewUser from '../../Components/Access/AccessAddNewUser';
import DynamicButton from '../../Components/Buttons/DynamicButton';
  
function SettingAccessDetailPage() {
  const globalState = useUserStore();
  const [role, setRole] = useState({});
  const [user, setUser] = useState([]);
  const [access, setAccess] = useState([]);
  const [changes, setChanges] = useState([]);
  const param = useParams()
  const toast = useToast();
  
  const paths = data;
  const accessList = extractPaths(paths);
  
  const getData = async () => {
    try {
      const res = await getSingleDocumentFirebase('role_access', param?.id);
      setRole(res);
      if (res?.users?.length > 0) {
        getUser(res.users, false);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  };
  
  const getAccess = async () => {
    try {
      const res = await getCollectionFirebase('role_access_data', [{ field: 'roleAccessId', operator: '==', value: param?.id }]);
      if (res?.length === 0) return;
  
      const mapped = [];
      for (const x of accessList) {
        const sub = [];
        for (const y of x) {
          const set = res?.find((item) => item?.path === y?.path);
          if (set) {
            sub.push(set);
          } else {
            const roleAccessData = {
              roleAccessId: param?.id,
              projectId: globalState?.currentProject,
              companyId: globalState?.currentCompany,
              path: y?.path,
              action: [],
            };
            const docId = await addDocumentFirebase('role_access_data', roleAccessData, globalState?.currentCompany);
            sub.push({ id: docId, ...roleAccessData });
            setChanges((prev) => {
              const newNewAccess = [...prev];
              newNewAccess.push({ id: docId, ...roleAccessData });
  
              return newNewAccess;
            });
          }
        }
        mapped.push(sub);
      }
  
      setAccess(mapped);
    } catch (e) {
      throw new Error(e.message);
    }
  };
  
  const getUser = async (list, isNew) => {
    try {
      const userList = [];
      if (list?.length > 0) {
        const promise = list?.map(async (x) => {
          const res = await getSingleDocumentFirebase('users', x);
          userList.push(res);
        });
        await Promise.all(promise);
        setUser((prev) => {
          if (isNew) {
            return [...userList, ...prev];
          } else {
            return [...prev, ...userList];
          }
        });
      }
    } catch (e) {
      throw new Error(e.message);
    }
  };
  
  const handleSave = async () => {
    try {
      if (!param?.id || !role) return;
      await updateDocumentFirebase('role_access', param?.id, role);
      const promises = access?.map(async (x) =>
        x?.map(async (y) => {
          const docId = y?.id;
          if (docId) delete y.id;
          else return;
          await updateDocumentFirebase('role_access_data', docId, y);
        })
      );
      await Promise.all(promises);
      toast({
        title: 'Perubahan role access berhasil disimpan',
        status: 'success',
        duration: 3000,
      });
    } catch (e) {
      throw new Error(e.message);
    }
  };
  
  const removeUser = async (id) => {
    const roleIdx = role?.users?.findIndex((x) => x === id);
    if (roleIdx > -1)
      setRole((prev) => {
        const newRole = { ...prev };
        newRole.users.splice(roleIdx, 1);
  
        return newRole;
      });
  
    const userIdx = user?.findIndex((x) => x?.id === id);
    if (userIdx > -1)
      setUser((prev) => {
        const newUser = [...prev];
        newUser.splice(userIdx, 1);
  
        return newUser;
      });
  };
  
  useEffect(() => {
    if (globalState?.currentProject && globalState?.currentCompany && param?.id) {
      getData();
      getAccess();
    }
  }, [globalState?.currentProject && globalState?.currentCompany && param?.id]);
  
  return (
    <Stack p={[1, 1, 5]} spacing={5}>
      <HStack>
        <BackButtons />
        <Heading size="md">Role Access View</Heading>
        <Spacer />
        <AccessAddNewUser role={role} setRole={setRole} getUser={getUser} />
        <DynamicButton action="update" variant="solid" title="Save" onClick={() => handleSave()} />
      </HStack>
  
      <HStack>
        <Text fontWeight="500">Nama Role:</Text>
        <Text>{role?.title}</Text>
      </HStack>
  
      <Tabs>
        <TabList>
          <Tab>Users</Tab>
          <Tab>Access</Tab>
        </TabList>
  
        <TabPanels>
          <TabPanel>
            <TableContainer borderRadius="10px" borderWidth="1px" borderColor={useColorModeValue('gray.100', 'gray.600')}>
              <Table>
                <Thead>
                  <Tr>
                    <Th>Name</Th>
                    <Th>Email</Th>
                    <Th>Aksi</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {user?.map((x, i) => (
                    <Tr key={i} cursor="pointer" _hover={{ bg: useColorModeValue('gray.100', 'gray.700') }}>
                      <Td>{x?.name || ''}</Td>
                      <Td>{x?.email || ''}</Td>
                      <Td>
                        <DynamicButton
                          action="delete"
                          size="sm"
                          variant="solid"
                          disabled={role?.title === 'users' ? true : false}
                          onClick={() => removeUser(x?.id)}
                        />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </TabPanel>
          <TabPanel>
            <AccessPathTabs access={access} setAccess={setAccess} changes={changes} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Stack>
  );
}
  
export default SettingAccessDetailPage;
  